import { Component, OnInit } from '@angular/core';

import { SharedRankingListService } from 'src/app/@theme/components/shared-ranking-list/shared-ranking-list.service';

import * as Constants from 'src/app/core/constants';

@Component({
    selector: 'app-wheelchair-ranking',
    templateUrl: './wheelchair-ranking.component.html',
    styleUrls: ['./wheelchair-ranking.component.scss'],
})
export class WheelchairRankingComponent implements OnInit {
    /**
     * Definição da identificão da sessão/depto Senior
     */
    constants = Constants;
    public departmentType: string = this.constants.DEPARTMENT_TYPE_WHEELCHAIR;
    public pathRoute: string = this.constants.DEPARTMENT_PATH_WHEELCHAIR;

    constructor(private rankingListService: SharedRankingListService) {}

    ngOnInit(): void {}
}
